import * as React from "react"
import type { SVGProps } from "react"
const SvgLayoutMasonry = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M15 7.57h4v-2h-4zm-10 4h4v-6H5zm10 8h4v-6h-4zm-10 0h4v-2H5zm8.29-10.29q.29.3.71.3h6q.42 0 .71-.3a1 1 0 0 0 .29-.71v-4a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29h-6a1 1 0 0 0-.71.29 1 1 0 0 0-.29.71v4q0 .42.29.71m-10 4q.29.3.71.3h6q.42 0 .71-.3a1 1 0 0 0 .29-.71v-8a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29H4a1 1 0 0 0-.71.29 1 1 0 0 0-.29.71v8q0 .42.29.71m10 8q.29.3.71.3h6q.42 0 .71-.3a1 1 0 0 0 .29-.71v-8a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29h-6a1 1 0 0 0-.71.29 1 1 0 0 0-.29.71v8q0 .42.29.71m-10 0q.29.3.71.3h6q.42 0 .71-.3a1 1 0 0 0 .29-.71v-4a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29H4a1 1 0 0 0-.71.29 1 1 0 0 0-.29.71v4q0 .42.29.71"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgLayoutMasonry
